import * as moment from "moment";
export var previousDay = new Date(new Date().setDate(new Date().getDate() - 1));
export var TodaysDate = new Date(new Date().setDate(new Date().getDate()));
export var TommorrowsDate = new Date(new Date().setDate(new Date().getDate() + 1));
export var holdingDownloadDate = new Date(2022, 2, 31);
export var firstNovememberDate = new Date(2022, 11, 1); //added for sales journey used in open meeting redirection added by Pranav
export var pnlDownloadDate = new Date(2013, 2, 31);
export var getDay = function (to) {
    return new Date().setDate(new Date().getDate() + to);
};
export var getDateInFormat = function (date, format) {
    return moment(date).format(format);
};
export var getTimeFormat = function (milliseconds, hourFormat) {
    if (!hourFormat) {
        hourFormat = 12;
    }
    var timeObj = {
        seconds: Math.floor((milliseconds / 1000) % 60).toString(),
        minutes: Math.floor((milliseconds / 1000 / 60) % 60).toString(),
        hours: Math.floor((milliseconds / 1000 / 60 / 60) % hourFormat).toString(),
    };
    return timeObj;
};
// export const getFinancialYear = (date: Date) => {
//   if (date < new Date(date.getFullYear(), 3, 1)) {
//     return date.getFullYear() - 1;
//   } else return date.getFullYear();
// };
export var getFinancialYears = function (startDate, endDate, isTillDate) {
    if (isTillDate === void 0) { isTillDate = false; }
    if (startDate && endDate) {
        var startYear = getFinancialYear(startDate);
        var endYear = getFinancialYear(endDate);
        var adjustedEndYear = isTillDate ? endYear : endYear + 1;
        return {
            start: startYear.toString().substring(2),
            end: endYear.toString().substring(2),
            label: "FY ".concat(startYear, "-").concat(adjustedEndYear.toString().substring(2)),
        };
    }
};
export var getDefaultDateRanges = function (numberOfDays, format) {
    return {
        startDate: moment().subtract(numberOfDays, "days").format(format),
        endDate: moment().format(format),
    };
};
export var getFormattedDateTime = function (date, time) {
    var updatedDate = moment(date).format("DD-MMM-YY");
    return updatedDate + ", " + time;
};
export var convertNumOfMonthsToYears = function (numOfMonths) {
    return Math.floor(Number(numOfMonths) / 12);
};
export var ipoRemainigDays = function (date, type) {
    return moment(date).diff(moment().format("DD-MMM-YY"), "days") === 0
        ? "Closing Today"
        : "Day ".concat(moment(date).diff(moment().format("DD-MMM-YY"), "days"), " ");
};
export var IDiffTypes;
(function (IDiffTypes) {
    IDiffTypes["DAYS"] = "days";
    IDiffTypes["YEARS"] = "years";
})(IDiffTypes || (IDiffTypes = {}));
export var daysDifferenceFromCurrent = function (date, type) {
    return moment(date).diff(moment().format("DD-MMM-YY"), type ? type : "days");
};
export var getFinancialFirstDay = function () {
    if (new Date() >= new Date(new Date().getFullYear(), 3, 1)) {
        return new Date(new Date().getFullYear(), 3, 1);
    }
    else {
        return new Date(new Date().getFullYear() - 1, 3, 1);
    }
};
// Get the start date and end date of this month with following conditions
// 1) If today is 1st of the month give dates of previous month
// 2) Dates should not exceed yesterday's date
export var getThisMonthStartAndEndDate = function () {
    var today = moment();
    // If today is the 1st of the month, get dates of the previous month
    var startDate = today.clone().startOf("month");
    if (today.date() === 1) {
        startDate.subtract(1, "month");
    }
    // End of the current month, but not exceeding yesterday
    var endDate = moment.min(today.clone().endOf("month"), moment().subtract(1, "day"));
    return {
        startDate: startDate,
        endDate: endDate,
    };
};
export var isFirstDateOfQuarter = function () {
    var today = moment();
    var currentQuarterStart = moment().startOf("quarter");
    return today.isSame(currentQuarterStart, "day");
};
export var getPreviousIndianFinancialYear = function () {
    var today = moment();
    var currentYear = today.year();
    var financialYearStartMonth = 3; // April (0-indexed)
    var startDate, endDate;
    if (today.month() < financialYearStartMonth) {
        startDate = moment([currentYear - 2, financialYearStartMonth, 1]);
        endDate = moment([currentYear - 1, financialYearStartMonth, 1]).subtract(1, "day");
    }
    else {
        startDate = moment([currentYear - 1, financialYearStartMonth, 1]);
        endDate = moment([currentYear, financialYearStartMonth, 1]).subtract(1, "day");
    }
    return {
        startDate: startDate,
        endDate: endDate,
    };
};
export var isFirstDayOfFinancialYear = function () {
    var today = moment();
    var financialYearStart = moment([today.year(), 3, 1]); // April (0-indexed)
    return today.isSame(financialYearStart, "day");
};
//get the start date and end date of current indian financial year using moment js
//ensuring that the end date does not exceed today's date
export var getCurrentIndianFinancialYear = function () {
    var yesterday = moment().subtract(1, "day");
    var currentYear = yesterday.year();
    var financialYearStartMonth = 3; // April (0-indexed)
    var startDate, endDate;
    if (yesterday.month() < financialYearStartMonth) {
        startDate = moment([currentYear - 1, financialYearStartMonth, 1]);
        endDate = moment.min(moment([currentYear, financialYearStartMonth, 1]).subtract(1, "day"), yesterday);
    }
    else {
        startDate = moment([currentYear, financialYearStartMonth, 1]);
        endDate = moment.min(moment([currentYear + 1, financialYearStartMonth, 1]).subtract(1, "day"), yesterday);
    }
    return {
        startDate: startDate,
        endDate: endDate,
    };
};
export var getFinancialYear = function (date) {
    var localDate = new Date();
    if (date !== null && date !== undefined) {
        localDate = date;
    }
    if (localDate < new Date(localDate.getFullYear(), 3, 1)) {
        return localDate.getFullYear() - 1;
    }
    else
        return localDate.getFullYear();
};
export var futureMonth = function (currentDate, numberOfMonthAhead) {
    return moment(currentDate).add(numberOfMonthAhead, "M").toDate();
};
export var futureDate = function (currentDate, numberOfAhead, format) { return moment(currentDate).add(numberOfAhead, format).toDate(); };
export var getBackMonths = function (date, numberOfMonthBehind) {
    return moment(date).subtract(numberOfMonthBehind, "M").toDate();
};
export var subtractDays = function (currentDate, numOfDays) {
    return moment(currentDate).subtract(numOfDays, "days").toDate();
};
export var getStartAndEndDates = function (name) {
    var startDate = "", endDate = "";
    if (name && name !== " ") {
        startDate = moment().startOf(name).toDate();
        endDate = moment().endOf(name).toDate();
    }
    return { startDate: startDate, endDate: endDate };
};
export var getDaysDifference = function (startDate, endDate) {
    endDate = moment(endDate).endOf("day").toDate();
    startDate = moment(startDate).startOf("day").toDate();
    return moment(endDate).diff(startDate, "days");
};
export var getDate = function (date) {
    return moment(date).toDate();
};
export var getLocalISOString = function (date) {
    var tzoffset = date.getTimezoneOffset() * 60000;
    var localISOTime = new Date(date.getTime() - tzoffset).toISOString();
    return localISOTime;
};
export var ETimeRange;
(function (ETimeRange) {
    ETimeRange["THIS_MONTH"] = "This Month";
    ETimeRange["LAST_MONTH"] = "Last Month";
    ETimeRange["THIS_QUARTER"] = "This Quarter";
    ETimeRange["LAST_QUARTER"] = "Last Quarter";
    ETimeRange["YEARLY"] = "Yearly";
    ETimeRange["TILL_DATE"] = "Till Date";
    ETimeRange["CUSTOM_TIME_RANGE"] = "Custom Time Range";
})(ETimeRange || (ETimeRange = {}));
export var addDays = function (date, days) {
    var newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
